import store from '@/stores/index'
import { formatDate } from '@/utils/filters'
import useragent from '@finance/useragent'
import { urlParams } from '@common/loan-act/util'

/**
 * 埋点数据模版扩展
 */
const collectDataExt = () => {
  const { account = '', guestAccount = '', userid = '' } = store.state.common.profile
  const { UUID, productName, appVersion } = store.getters.phoneInfo
  const timestrap = new Date().getTime()
  const systemName = (() => {
    if (useragent.isAndroid) {
      return 'android OS'
    } else if (useragent.isIOS) {
      return 'iPhone OS'
    }
    return 'other'
  })()
  const systemVersion = (() => {
    if (useragent.isAndroid || useragent.isIOS) {
      return useragent.os.version
    }
    return 'unknown'
  })()

  return {
    uuid: UUID,
    uid: account || guestAccount,
    time: formatDate(timestrap, 'YYYY-MM-DD hh:mm:ss'),
    user_agent: window.navigator.userAgent,
    uri: window.location.href,
    // action: pageName,
    systemname: systemName,
    systemversion: systemVersion,
    productname: productName,
    productversion: appVersion,
    remarks: '',
    user_id: userid,
    book_id: '',
    book_market_id: '',
    dfrom: JSON.stringify({ abtest: '', entry: urlParams().source || '' })
  }
}

export default collectDataExt
